<div class="relative w-full">
    <input type="text"
        class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 pr-11 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:bg-gray-900 dark:placeholder:text-white/30 dark:focus:border-brand-800"
        [ngClass]="[
            invalid ? 'border-red-400 dark:border-red-500 focus:border-red-400' : 'border-gray-300 dark:border-gray-600 focus:border-brand-300',
            value ? 'text-gray-800 dark:text-white/90' : 'text-gray-400 dark:text-gray-400',
            disabled ? 'opacity-50 cursor-not-allowed' : '',
            className
        ]"
        [placeholder]="'— ' + placeholder + ' —'"
        [value]="searchTerm"
        [readonly]="behaveAsSelect"
        [disabled]="disabled"
        [ngStyle]="{'cursor': disabled ? 'not-allowed' : (behaveAsSelect ? 'pointer' : 'text')}"
        name="select-search-{{ randomId }}"
        [attr.autocomplete]="'new-password'"
        (input)="onInput($event)"
        (click)="!disabled && toggleDropdown()"
        (blur)="onTouched()" />

    <div class="flex gap-1 absolute right-3 top-1/2 -translate-y-1/2 bg-white dark:bg-gray-900 cursor-pointer"
        [ngClass]="{'pointer-events-none opacity-50': disabled}" (click)="!disabled && toggleDropdown()">
        @if(!behaveAsSelect && searchTerm){
        <i class="bi bi-x text-gray-500" (click)="!disabled && clearSelection()"></i>
        }
        <i class="bi bi-chevron-down pointer-events-none text-gray-500 transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isOpen }"></i>
    </div>

    @if (isOpen) {
    <ul class="z-50 rounded-lg border dark:border-gray-600 border-gray-300 bg-white dark:bg-gray-800 dark:text-white text-gray-800 shadow overflow-auto custom-scrollbar"
        [class.absolute]="!floating"
        [class.w-full]="!floating"
        [class.fixed]="floating"
        [ngClass]="[dropdownMaxHeight]"
        [ngStyle]="floating ? dropdownStyle : null">
        @if (withCreateActionButton) {
        <li class="text-responsive-ellipsis add-client px-3 py-2 border-b border-gray-300 dark:border-gray-600 hover:bg-gray-100 cursor-pointer dark:hover:bg-gray-700"
            (mousedown)="navigateToAction()">
            <i class="bi {{ actionButtonIcon }}"></i> Agregar {{ actionButtonText }}
        </li>
        }

        @for(option of filteredOptions; track option.value) {
        <li (mousedown)="selectOption(option)" class="text-responsive-ellipsis px-4 py-2 cursor-pointer text-sm" [ngClass]="{
                'hover:bg-blue-700 bg-blue-700 text-white': option.value === value,
                'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-white': option.value !== value
            }">
            @if (option.icon) {
            <span class="inline-flex items-center gap-2"><i [class]="option.icon"></i><span>{{ option.label }}</span></span>
            } @else {
            {{ option.label }}
            }
        </li>
        }
        @empty {
        <li class="px-4 py-2 text-gray-400 text-sm flex justify-start items-center h-full">No hay resultados</li>
        }
    </ul>
    }
</div>